import React from 'react';
import { ExternalLink, FileText } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface ContractViewerProps {
  contractUrl: string;
  title?: string;
  className?: string;
}

export const ContractViewer: React.FC<ContractViewerProps> = ({ 
  contractUrl, 
  title = 'View Contract',
  className = '' 
}) => {
  const { translations } = useLanguage();

  if (!contractUrl) {
    return null;
  }

  return (
    <a
      href={contractUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-2 px-4 py-2 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 transition-colors ${className}`}
    >
      <FileText size={18} />
      <span>{title}</span>
      <ExternalLink size={16} />
    </a>
  );
};